import type { AnalysisSpecItem } from '@/model/analysisSpec/dto.generated';
import type { ETLSourceResponse } from '@/model/etlSource/dto.generated';
import type { FailureSummaryResponse } from '@/model/observability/dto.generated';

export const TOAST_DURATION_MS = 3750;

export function specKey(name: string, version: number): string {
  return `${name}-${version}`;
}

export function latestSpecsByName(specs: readonly (AnalysisSpecItem | null)[]): AnalysisSpecItem[] {
  const map = new Map<string, AnalysisSpecItem>();
  for (const spec of specs) {
    if (!spec?.analysis_spec_name) continue;
    const prev = map.get(spec.analysis_spec_name);
    if (!prev || spec.version > prev.version) map.set(spec.analysis_spec_name, spec);
  }
  return [...map.values()];
}

export function toSourceMap(sources: readonly ETLSourceResponse[]): Map<string, ETLSourceResponse> {
  const map = new Map<string, ETLSourceResponse>();
  for (const s of sources) {
    if (s.id) map.set(s.id, s);
  }
  return map;
}

export function causeFromSummary(summary: FailureSummaryResponse | undefined): string | undefined {
  const first = summary?.failures?.[0];
  return first?.error_message ?? first?.error_kind;
}
